export type CroppedAreaPixels = {
	width: number, 
	height: number, 
	x: number, 
	y: number,
}

export const createImage = (url: string) => {
	return new Promise((resolve, reject) => {
	  const image = new Image()
	  image.addEventListener('load', () => resolve(image))
	  image.addEventListener('error', (error) => reject(error))
	  image.setAttribute('crossOrigin', 'anonymous')
	  image.src = url
	})
}	

export const getRadianAngle = (degreeValue: number) => {
	return (degreeValue * Math.PI) / 180
}

const rotateSize = (width: number, height: number, rotation: number) => {
	const rotRad = getRadianAngle(rotation)
  
	return {
	  width:
		Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
	  height:
		Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
	}
  }

  export async function getCroppedImage(
	imageSource: string,
	croppedAreaPixels: CroppedAreaPixels,
	rotation = 0,
	quality: number = 0.9,
	flip = { horizontal: false, vertical: false }
): Promise<Blob | null> {

	const image = await createImage(imageSource) as unknown as HTMLImageElement;
	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')
  
	if (!ctx) {
		  return null
	}
  
	const rotRad = getRadianAngle(rotation)
  
	// calculate bounding box of the rotated image
	const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
		image.width,
		image.height,
		rotation
	)
  
	// set canvas size to match the bounding box
	canvas.width = bBoxWidth
	canvas.height = bBoxHeight
  
	// translate canvas context to a central location to allow rotating and flipping around the center
	ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
	ctx.rotate(rotRad)
	ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
	ctx.translate(-image.width / 2, -image.height / 2)
  
	// draw rotated image
	ctx.drawImage(image, 0, 0)
  
	const croppedCanvas = document.createElement('canvas')
  
	const croppedCtx = croppedCanvas.getContext('2d')
  
	if (!croppedCtx) {
		  return null
	}
  
	// Set the size of the cropped canvas
	croppedCanvas.width = croppedAreaPixels.width
	croppedCanvas.height = croppedAreaPixels.height
  
	// Draw the cropped image onto the new canvas
	croppedCtx.drawImage(
		canvas,
		croppedAreaPixels.x,
		croppedAreaPixels.y,
		croppedAreaPixels.width,
		croppedAreaPixels.height,
		0,
		0,
		croppedAreaPixels.width,
		croppedAreaPixels.height
	)
  
	return new Promise((resolve) => {
		return croppedCanvas.toBlob(
			(blob) => { resolve(blob); },
			'image/jpeg', // force JPEG compressible
			quality,
		)
	})
}